import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  bottomText: {
    alignItems: 'center',
    display: 'flex',
    gap: 12,
  },
  box: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.04)',
    gap: 8,
    padding: '24px',
  },
  contentContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: 24,
  },
  date: {
    color: '#666',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: 'semibold',
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: 36,
    fontWeight: 'semibold',
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 'semibold',
  },
})
